import { render, staticRenderFns } from "./INRIcon.vue?vue&type=template&id=719ab77c&"
import script from "./INRIcon.vue?vue&type=script&lang=js&"
export * from "./INRIcon.vue?vue&type=script&lang=js&"
import style0 from "./INRIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports